import { FetchAttr } from '../types';
import { postData } from '../utils';

export type PostProductsByLetterRequest = {
  tradeNames: { translitName: string; name: string }[];
  totalCount: number;
};

const postProductsByLetter = async (
  requestObj: { pageNumber: number; letter: string; pageSize: number },
  attr?: FetchAttr
): Promise<PostProductsByLetterRequest> => {
  const response = await postData(`tradenames`, requestObj, attr);
  return response;
};

export default postProductsByLetter;
